var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil } from 'rxjs/operators';
import { ViewBreakpoint } from '../../models/view-breakpoint.enum';
import { ColorUtils } from 'src/app/shared/libraries/colors/colors';
var ViewLogoComponent = /** @class */ (function () {
    function ViewLogoComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.isLight = true;
        this.viewBreakpoint = ViewBreakpoint;
        this.ngUnsubscribe = new Subject();
    }
    ViewLogoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.background$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (background) {
            _this.updateLogoColor(background);
        });
    };
    ViewLogoComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewLogoComponent.prototype.updateLogoColor = function (background) {
        if (!background.colors) {
            return;
        }
        var outerRGB = background.colors.slice(0, 3);
        this.isLight = ColorUtils.isLight(outerRGB);
        this.changeDetectorRef.markForCheck();
    };
    __decorate([
        Select(ViewState.getLayout),
        __metadata("design:type", Observable)
    ], ViewLogoComponent.prototype, "layout$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], ViewLogoComponent.prototype, "background$", void 0);
    __decorate([
        Select(ViewState.getBreakpoint),
        __metadata("design:type", Observable)
    ], ViewLogoComponent.prototype, "breakpoint$", void 0);
    return ViewLogoComponent;
}());
export { ViewLogoComponent };
